<button
  class="cta variant-{{ variant }} size-{{ size }}"
  type="button"
  (click)="handleClick($event)"
  [routerLink]="routerLink || null"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel || text"
  [attr.title]="title || text">

  <span>
    <span *ngIf="icon" class="button-icon" aria-hidden="true">
      <i [class]="icon"></i>
    </span>

    <span class="button-label">{{ text }}</span>

    <kbd *ngIf="shortcut" class="button-shortcut">{{ shortcut }}</kbd>
  </span>

</button>